import { format } from 'date-fns';

const DATE_FNS_FORMAT = 'h:mmaaa';

/**
 * Formats a message timestamp in milliseconds to a readable time string
 * used in the MessageList (individual messages in a thread)
 * @param messageDateMs - The message date in milliseconds
 * @returns Formatted time string (e.g., "2:30pm")
 */
export default function getMessageTimestampText(messageDateMs: string): string {
  if (!messageDateMs) return '';
  return format(new Date(+messageDateMs), DATE_FNS_FORMAT);
}
